import React from 'react';
//import Constants from '../Config/Config';

export const Loader = () => {
    return  <div className="spinner">
                <div className="bounce1"></div>
                <div className="bounce2"></div>
                <div className="bounce3"></div>
            </div>;
}

export const ErrorHandle = (props) => {
	const {errorText, error} = props;
	if(error){
	  return (
	    <div className="alert alert-danger">{errorText}</div>
	  );
	}
	return (null);
}

export function roundToTwo(num) {
    return +(Math.round(num + "e+2")  + "e-2");
}

export function checkFramedSize(framedCalc, frameSizeW, frameSizeH) {
    if (framedCalc.size === 0)
       return false

    var error = true;
    const maximum_allowed_framed_width = parseFloat(framedCalc.getIn(['acf', 'maximum_allowed_framed_width_pocm']));
    const maximum_allowed_framed_height = parseFloat(framedCalc.getIn(['acf', 'maximum_allowed_framed_height_pocm']));

    /*console.log('------------------')
    console.log(maximum_allowed_framed_width)
    console.log(maximum_allowed_framed_height)
    console.log('------------------')
    console.log(frameSizeW)
    console.log(frameSizeH)
    console.log('------------------')*/

    if (frameSizeH <= maximum_allowed_framed_height && frameSizeW <= maximum_allowed_framed_width) {
        error = false;
    } else if (frameSizeW <= maximum_allowed_framed_height && frameSizeH <= maximum_allowed_framed_width) {
        error = false;
    }
    return error;
}